<template>
  <div class="vueroot">
    <div class="headerbar" style="background-color:#202536;position: relative;top: -50px;">
    <!--图标-->
      <el-row height="50px">
        <el-col :span="4">
          <img src="static/logo.png" width="100%" height="100%">
        </el-col>
        <el-col :span="20">
          <h1 style="color:white;"> 低维体系数据库Low-Dimensional Systems (LODS: http://lods.org.cn/ ) </h1>
        </el-col>
      </el-row>
    </div>
    <h1>{{ structurename }}</h1>
    <el-row>
        <el-col :span=18>
        <div id="crystal3dvue"></div>
        <tdmolview :cifcontent="cifstring"></tdmolview>
        </el-col>
        <el-col :span=6>
            <el-row>
                <el-table :data="frompaper">
                    <!-- title -->
                    <el-table-column
                        label="Title"
                        prop="name">
                        <template slot-scope="scope">
                            <a :href="scope.row.url">{{ scope.row.name }}</a>
                        </template>
                        </el-table-column>
                    <el-table-column label="Author" prop="author"></el-table-column>
                    <!--url, click will goto the page-->
                </el-table>
            </el-row>
            <el-row>
            <div id="property">
                <el-table :data="propertydata" v-infinite-scroll="load">
                    <el-table-column prop="name" label="Property Name"></el-table-column>
                    <el-table-column prop="value" label="Value"></el-table-column>
                </el-table>
            </div>
            </el-row>
        </el-col>
    </el-row>
    <el-row>
        <h2>gallery</h2>
        <!--展示一些图片-->
            <el-col :span=24>
                <el-carousel height="250px" :autoplay="true" :autoplay-interval="3000" arrow="true" :indicator="false">
                    <el-carousel-item v-for="(item,index) in gallerypic" :key="index">
                        <img :src="item.url" :key="index" />
                    </el-carousel-item>
                </el-carousel>
            </el-col>
    </el-row>
    <el-row>
        <h2>一些图表</h2>
    </el-row>
    <!-- 显示结果-->
    <el-row>
        <h2>Result</h2>
        <div class="results">
            <!-- 折叠显示每个结果的详细信息 -->
            <el-collapse  accordion>
                <el-collapse-item v-for="(item,index) in resultsdoc" :key="index" :title="item.name">
                        <p>Software: {{ item.data.software+"  "+item.data.softwareVersion }}</p>
                        <p>Method: {{ item.data.method }}</p>
                        <div v-for="(inputfile,key,iindex) in (item.data.inputfile)" :key="iindex">
                            <h3>{{ key }}</h3>
                            <el-col>
                           <el-input type="textarea" :value="inputfile" placeholder="inputfile"></el-input>
                            </el-col>
                        </div>
                        <el-row>
                        <div id="propertyr">
                            <el-table :data="item.data.property" >
                                <el-table-column prop="name" label="Property Name"></el-table-column>
                                <el-table-column prop="value" label="Value"></el-table-column>
                            </el-table>
                        </div>
                        </el-row>
                        <!-- 结果文件的列表 -->
                        <el-row>
                            <h3>Result File</h3>
                            <ul>
                                <li v-for="(file,key,index) in item.data.resultsFile" :key="index">
                                    <a :href="file.url">{{ key }}</a>
                                </li>
                            </ul>
                        </el-row>
                </el-collapse-item>
            </el-collapse>
        </div>
    </el-row>
  </div>
</template>

<script>
// import CrystVis from 'crystvis-js'
import tdmolview from './subcomponents/tdmolview.vue'
export default {
  name: 'structure',
  components: {
    tdmolview
  },
  data () {
    // var cifstring0 = ""
    // var msg0 = this.$route.params.id
    // var  structurename0 = ''
    // var  cifstring0 = ''
    // var  propertydata0 = []
    // var  gallerypic0 = []
    // var  resultsdoc0 = []
    // var  frompaper0 = []
    // this.$ajax.get('/api/v0/structure/' + String(this.$route.params.id)).then(
    //   res => {
    //     var rdata = res.data
    //     // var cifstring = rdata.structureFileCif
    //     let cifstring0 = rdata.structureFileCif
    //     // var loaded = visualizer.loadModels(cifstring)
    //     // console.log('Models loaded: ', loaded)
    //     // visualizer.displayModel(Object.keys(loaded)[0])
    //     console.log(typeof res)
    //     window.temp = res
    //     var newpropertydata = []
    //     for (var k0 in rdata.property) {
    //       newpropertydata.push({
    //         'name': k0,
    //         'value': rdata.property[k0]
    //       })
    //     }
    //     var newgallerypic = []
    //     for (var k in rdata.pictures) {
    //       newgallerypic.push({'id': rdata.pictures[k].$oid, 'name': k, 'url': this.$ajax.defaults.baseURL + '/api/v0/files/' + rdata.pictures[k].$oid})
    //     }
    //     var newresultsdoc = []
    //     for (k in rdata.resultsdoc) {
    //       var tempdata = rdata.resultsdoc[k]
    //       var reultproperty = []
    //       for (var k1 in tempdata.property) {
    //         reultproperty.push({
    //           'name': k1,
    //           'value': tempdata.property[k1]
    //         })
    //       }
    //       tempdata.property = reultproperty
    //       for (var k2 in tempdata.resultsFile) {
    //         tempdata.resultsFile[k2]['url'] = this.$ajax.defaults.baseURL + '/api/v0/files/' + tempdata.resultsFile[k2].$oid
    //       }
    //       newresultsdoc.push({'name': k, 'data': tempdata})
    //     }
    //     this.resultsdoc = newresultsdoc
    //     this.frompaper = rdata.froms
    //     this.gallerypic = newgallerypic
    //     this.propertydata = newpropertydata
    //     this.structurename = rdata.name
    //   })
    return {
      msg: this.$route.params.id,
      structurename: '',
      cifstring: '',
      propertydata: [],
      gallerypic: [],
      resultsdoc: [],
      frompaper: []
    }
  },
  mounted () {
    // const visualizer = new CrystVis('#crystal3dvue', 800, 600)
    // window.visualizer = visualizer
    this.$ajax.get('/api/v0/structure/' + String(this.$route.params.id)).then(
      res => {
        var rdata = res.data
        // var cifstring = rdata.structureFileCif
        this.cifstring = rdata.structureFileCif
        // var loaded = visualizer.loadModels(cifstring)
        // console.log('Models loaded: ', loaded)
        // visualizer.displayModel(Object.keys(loaded)[0])
        console.log(typeof res)
        window.temp = res
        var newpropertydata = []
        for (var k0 in rdata.property) {
          newpropertydata.push({
            'name': k0,
            'value': rdata.property[k0]
          })
        }
        var newgallerypic = []
        for (var k in rdata.pictures) {
          newgallerypic.push({'id': rdata.pictures[k].$oid, 'name': k, 'url': this.$ajax.defaults.baseURL + '/api/v0/files/' + rdata.pictures[k].$oid})
        }
        var newresultsdoc = []
        for (k in rdata.resultsdoc) {
          var tempdata = rdata.resultsdoc[k]
          var reultproperty = []
          for (var k1 in tempdata.property) {
            reultproperty.push({
              'name': k1,
              'value': tempdata.property[k1]
            })
          }
          tempdata.property = reultproperty
          for (var k2 in tempdata.resultsFile) {
            tempdata.resultsFile[k2]['url'] = this.$ajax.defaults.baseURL + '/api/v0/files/' + tempdata.resultsFile[k2].$oid
          }
          newresultsdoc.push({'name': k, 'data': tempdata})
        }
        this.resultsdoc = newresultsdoc
        this.frompaper = rdata.froms
        this.gallerypic = newgallerypic
        this.propertydata = newpropertydata
        this.structurename = rdata.name
      }
    )
  },
  methods: {
    viewit (it) {
      console.log(it)
      this.$router.push({
        path: '/structure',
        query: {
          id: it
        }
      }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img  {
    /* width: 100%; */
    height:100%;
}
</style>



// WEBPACK FOOTER //
// src/components/structure.vue